export default __webpack_public_path__ + "static/media/frutiger-55roman.9785b9de.ttf";